"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatNumber = exports.NumberLocaleStringStyle = exports.EstimateCostOfInProgressSession = exports.GetPriceNumericValue = exports.GetDisplayPrice = void 0;
/**
 * Returns a string with a displayable price, taking in to account the precision of the price provided.
 *
 * @param price The price.
 * @param pricePrecision The precision of @see price.
 * @param formatOptions The options for formatting see FormatNumber for more.
 * @returns The displayable price.
 */
function GetDisplayPrice(price, pricePrecision, formatOptions) {
    if (price == null || pricePrecision == null) {
        return "0.00";
    }
    if (formatOptions) {
        return FormatNumber(GetPriceNumericValue(price, pricePrecision), formatOptions);
    }
    return GetPriceNumericValue(price, pricePrecision)
        .toFixed(pricePrecision)
        .toString();
}
exports.GetDisplayPrice = GetDisplayPrice;
function GetPriceNumericValue(price, pricePrecision) {
    const priceMultiplicand = Math.pow(10, pricePrecision);
    return price / priceMultiplicand;
}
exports.GetPriceNumericValue = GetPriceNumericValue;
/**
 * Estimates the cost of an ongoing session based on how much energy has been delivered. DOES NOT INCLUDE VAT
 * In the future should support charge-by-minute with a charging curve as a parameter.
 * @param pricing The Pricing object for the site.
 * @param energyDeliveredKwh The amount of energy delivered in the session.
 * @returns The cost in the same denomination of the pricePerKwhAmount, and the precision of the cost. Returns [-1, -1] for chargePerMinute pricing models.
 */
function EstimateCostOfInProgressSession(pricing, energyDeliveredKwh) {
    let raw;
    let precision;
    if (pricing.freemode) {
        raw = 0;
        precision = 2;
    }
    else if (pricing.pricePerKwh) {
        raw = pricing.pricePerKwh.amount?.amount ?? 0;
        precision = pricing.pricePerKwh.amount?.precision ?? 0;
    }
    else {
        /**
         * Charge Per Minute is unimplemented.
         */
        return [-1, -1];
    }
    /**
     * Round to the nearest cent (or other money denomination)
     */
    return [Math.round(energyDeliveredKwh * raw), precision];
}
exports.EstimateCostOfInProgressSession = EstimateCostOfInProgressSession;
var NumberLocaleStringStyle;
(function (NumberLocaleStringStyle) {
    NumberLocaleStringStyle["Decimal"] = "decimal";
    NumberLocaleStringStyle["Currency"] = "currency";
    NumberLocaleStringStyle["Percent"] = "percent";
    NumberLocaleStringStyle["Unit"] = "unit";
})(NumberLocaleStringStyle = exports.NumberLocaleStringStyle || (exports.NumberLocaleStringStyle = {}));
function FormatNumber(val, options) {
    if (val === undefined || val === null) {
        return "";
    }
    const maximumFractionDigits = options?.maximumFractionDigits ?? 2;
    const useLocaleString = options?.useLocaleString ?? false;
    const localeStringStyle = options?.localeStringStyle ?? NumberLocaleStringStyle.Decimal;
    // TODO: In the future we probably shouldn't default to USD, but we're currently working on the US Market.
    const currency = options?.localeStringStyle === NumberLocaleStringStyle.Currency
        ? options.currencyType ?? "USD"
        : undefined;
    return useLocaleString
        ? val.toLocaleString(undefined, {
            maximumFractionDigits,
            style: localeStringStyle,
            currency,
        })
        : val.toFixed(maximumFractionDigits);
}
exports.FormatNumber = FormatNumber;
